module.exports = __webpack_public_path__ + "static/media/Controle-01.0b77137e.svg";